<template>
    <div class="searchAll">
        <div v-if="status === 'normal'">
            <div
                v-if="resultList.contactsList.length > 0"
                class="searchContacts"
            >
                <div class="title">
                    <span>联系人</span>
                </div>
                <div class="member-box">
                    <label
                        v-for="(item, index) in resultList.contactsList.length >
                            3
                            ? resultList.contactsList.slice(0, 3)
                            : resultList.contactsList"
                        :key="index"
                        class="member"
                        :for="item.uId"
                        @change="checkContacts($event, item)"
                    >
                        <label
                            class="checkIcon"
                        ><input
                            :id="item.uId"
                            v-model="selectedIdList"
                            type="checkbox"
                            :value="item.uId"
                            :disabled="isDisabled(item)"
                        ><i /></label>
                        <Avatar :user="item" class="avatar" />
                        <div class="detail contact">
                            <p class="name">
                                <span
                                    class="name-flex"
                                    v-html="item.htmlName"
                                />
                                <span
                                    v-if="item.nickname"
                                    class="nick-name"
                                    v-html="' · ' + item.nickname"
                                />
                                <span
                                    v-if="!isBot(item)"
                                    class="account"
                                    v-html="item.htmlLxAccount"
                                />
                            </p>
                            <p class="position">
                                {{ item.department }}
                            </p>
                            <p
                                v-if="
                                    item.htmlPhone.indexOf(
                                        '<span class=\'search_high_light\'>'
                                    ) > -1
                                "
                                class="phone"
                            >
                                手机：
                                <span v-html="item.htmlPhone" />
                            </p>
                            <p v-if="item.isRecent" class="recent">
                                <span class="recentText">最近联系</span>
                            </p>
                            <p v-if="isDelete(item)" class="quit">
                                <span class="quitText">已离职</span>
                            </p>
                        </div>
                    </label>
                </div>
                <div
                    v-if="resultList.contactsList.length > 3"
                    class="viewAll"
                    @click="changeTabs('contacts')"
                >
                    <span class="viewText">查看全部</span>
                    <img
                        src="@/assets/images/contacts/arrow-right.png"
                        alt=""
                        class="viewIcon"
                    >
                </div>
                <div class="division">
                    <div class="line" />
                </div>
            </div>
            <div v-if="resultList.groupList.length > 0" class="searchGroups">
                <div class="title">
                    <span>群聊</span>
                </div>
                <div class="searchGroupDetail">
                    <div
                        v-for="(item, index) in resultList.groupList.length > 3
                            ? resultList.groupList.slice(0, 3)
                            : resultList.groupList"
                        :key="index"
                        class="main-box"
                    >
                        <label
                            class="member"
                            :for="item.targetId"
                            @change="checkGroups($event, item)"
                        >
                            <label
                                class="checkIcon"
                            ><input
                                :id="item.targetId"
                                v-model="selectedGroupIdList"
                                type="checkbox"
                                :value="item.targetId"
                                :half="isHalf(item)"
                            ><i /></label>
                            <GroupAvatar :group="item" class="avatar" />
                            <div class="detail group">
                                <p class="name">
                                    <span
                                        class="name-flex"
                                        v-html="item.htmlName"
                                    />
                                    <span
                                        class="group-count"
                                    >({{ item.memberCount }})</span>
                                </p>
                                <div
                                    v-if="
                                        item.memberList &&
                                            item.memberList.length > 0
                                    "
                                    class="position"
                                >
                                    包含：
                                    <template
                                        v-for="(memberItem,
                                                index2) in item.memberList"
                                    >
                                        <span
                                            :key="memberItem.lxAccount"
                                            v-html="
                                                memberItem.name +
                                                    (memberItem.nickname
                                                        ? '·' +
                                                            memberItem.nickname
                                                        : '') +
                                                    '(' +
                                                    memberItem.lxAccount +
                                                    ')'
                                            "
                                        />
                                        <template
                                            v-if="
                                                index2 !==
                                                    item.memberList.length - 1
                                            "
                                        >、</template>
                                    </template>
                                </div>
                            </div>
                        </label>
                    </div>
                </div>
                <div
                    v-if="resultList.groupList.length > 3"
                    class="viewAll"
                    @click="changeTabs('groups')"
                >
                    <span class="viewText">查看全部</span>
                    <img
                        src="@/assets/images/contacts/arrow-right.png"
                        alt=""
                        class="viewIcon"
                    >
                </div>
                <div class="division">
                    <div class="line" />
                </div>
            </div>
        </div>
        <div v-if="status === 'none'" class="org-status">
            <img
                src="@/assets/images/contacts/org-window-empty-bg.png"
                alt=""
                class="status-img"
            >
            <p class="status-text">
                找不到”<span class="no-data">{{ keyword }}</span>”相关的结果
            </p>
        </div>
        <Loading
            v-if="status === 'loading' && pageNumber === 1"
            :search-type="searchType"
        />
        <div v-if="status === 'dataLoadingFailed'" class="org-status">
            <img
                src="@/assets/images/contacts/data_loading_failed.png"
                alt=""
                class="status-img"
            >
            <p class="status-text">
                数据加载失败，请重试
            </p>
            <!--<div class="status-reload">-->
            <!--    <button type="button" class="reload" @click="reload()">-->
            <!--        重新加载-->
            <!--    </button>-->
            <!--</div>-->
        </div>
        <div v-if="status === 'serviceAbnormal'" class="org-status">
            <img
                src="@/assets/images/contacts/service_abnormal.png"
                alt=""
                class="status-img"
            >
            <p class="status-text">
                服务异常，请联系IT报事
            </p>
            <!--<div class="status-reload">-->
            <!--    <button type="button" class="reload" @click="reload()">-->
            <!--        重新加载-->
            <!--    </button>-->
            <!--</div>-->
        </div>
        <div v-if="status === 'networkAbnormal'" class="org-status">
            <img
                src="@/assets/images/contacts/network_abnormal.png"
                alt=""
                class="status-img"
            >
            <p class="status-text">
                当前网络不可用，请检查网络设置
            </p>
            <!--<div class="status-reload">-->
            <!--    <button type="button" class="reload" @click="reload()">-->
            <!--        重新加载-->
            <!--    </button>-->
            <!--</div>-->
        </div>
    </div>
</template>

<script>
import { contactsSearch } from '@/apis/contactsWindow/contactsWindow'
import Avatar from '@/components/Avatar/index'
import GroupAvatar from '@/components/GroupAvatar/index'
import Loading from './SkeletonScreen'
import { configer } from '@/config'

export default {
    name: 'SearchAll',
    components: {
        Avatar,
        GroupAvatar,
        Loading
    },
    props: {
        selected: {
            type: [Array],
            required: false,
            default: () => []
        },
        isStaff: {
            type: Boolean,
            required: true,
            default: false
        },
        loginRights: {
            type: Object,
            required: true
        },
        defaultSelected: {
            type: [Array],
            required: false,
            default: () => []
        },
        canNotSelected: {
            type: [Array],
            required: false,
            default: () => []
        },
        selectedGroups: {
            type: [Array],
            required: false,
            default: () => []
        },
        selectedHalfGroups: {
            type: [Array],
            required: false,
            default: () => []
        },
        groupSelectType: {
            type: [Number],
            required: true
        },
        keyword: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            fileTransferRobotId: configer.fileTransferRobotId,
            status: '',
            resultList: {
                contactsList: [],
                groupList: []
            },
            contactsListCache: {},
            groupListCache: {},
            pageNumber: 1, // 页数
            pageSize: 5, // 每页个数
            searchType: 'all'
        }
    },
    computed: {
        selectedIdList: {
            get() {
                return this.selected.map(item => item.id)
            },
            set() {}
        },
        selectedGroupIdList: {
            get() {
                return this.selectedGroups.map(item => item.id)
            },
            set() {}
        },
        defaultIdList() {
            return (this.defaultSelected || []).map(item => item.id)
        },
        canNotSelectedIds() {
            return this.canNotSelected || []
        },
        // 是否有通讯录权限:-1无权限;0低权限;1高权限
        userLevel() {
            return !this.loginRights.authorityGrade
                ? -1
                : +this.loginRights.authorityGrade
        }
    },
    watch: {
        keyword(val) {
            if (val) {
                this.status = 'loading'
            }
        }
    },
    methods: {
        // 搜索联系人
        getData(value, isChangeTab) {
            const context = this
            // 切换tab如果有缓存那么就不发请求
            if (
                isChangeTab &&
                context.contactsListCache[context.keyword] &&
                context.groupListCache[context.keyword]
            ) {
                context.resultList.contactsList =
                    context.contactsListCache[context.keyword]
                context.resultList.groupList =
                    context.groupListCache[context.keyword]
                context.status = 'normal'
                return
            }
            context.status = 'loading'
            context.pageNumber = 1
            const params = {
                keyword: value,
                channel: 'web',
                searchType: context.searchType,
                pageNumber: context.pageNumber,
                pageSize: context.pageSize
            }
            contactsSearch(params)
                .then(res => {
                    if (res.code === '0' && res.data !== null) {
                        if (context.keyword !== res.data.keyword) {
                            return
                        }
                        const resultList = res.data || []
                        if (
                            resultList.contactsList.length === 0 &&
                            resultList.groupList.length === 0
                        ) {
                            context.status = 'none'
                            return
                        }
                        context.resultList.contactsList = context.formatUserData(
                            resultList.contactsList
                        )
                        context.resultList.groupList = context.formatGroupData(
                            resultList.groupList
                        )
                        context.contactsListCache[context.keyword] =
                            context.resultList.contactsList // 缓存搜索到的联系人列表
                        context.groupListCache[context.keyword] =
                            context.resultList.groupList // 缓存搜索到的群聊列表
                        context.status = 'normal'
                    } else {
                        context.status = 'dataLoadingFailed'
                    }
                })
                .catch(err => {
                    console.warn(err)
                    if (err.message === 'Network Error') {
                        this.status = 'networkAbnormal' // 当前网络不可用，请检查网络设置
                    } else {
                        this.status = 'serviceAbnormal' // 服务异常，请联系IT报事
                    }
                })
        },
        // 格式化从后端获取的数据
        formatUserData(list) {
            const tempList = []
            const reg = /<\/?.+?>/g
            for (let i = 0; i < list.length; i++) {
                let obj = {}
                if (list[i].id) {
                    // list[i].lxAccount这个判断是为了兼容获取群详情里的staffs时format数据
                    obj = {
                        uId: list[i].id || '',
                        id: list[i].uId || '',
                        headId: list[i].headId || '',
                        portraitUrl: list[i].headPortrait || '',
                        htmlName: list[i].name || '',
                        htmlLxAccount: list[i].lxAccount
                            ? '(' + list[i].lxAccount + ')'
                            : '',
                        name: list[i].name ? list[i].name.replace(reg, '') : '',
                        nickname: list[i].nickname || '',
                        lxAccount: list[i].lxAccount
                            ? list[i].lxAccount.replace(reg, '')
                            : '',
                        userType: +list[i].userType || '',
                        isExec: +list[i].isExec || 0,
                        job: list[i].job || list[i].tag1 || '',
                        status: +list[i].status || 0,
                        department: list[i].department || '',
                        htmlPhone: list[i].phone || '',
                        isRecent: list[i].isRecent || ''
                    }
                    tempList.push(obj)
                }
            }
            return tempList
        },
        // 格式化从后端获取的数据
        formatGroupData(list) {
            const tempList = []
            const reg = /<\/?.+?>/g
            for (let i = 0; i < list.length; i++) {
                let obj = {}
                if (list[i].targetId) {
                    obj = {
                        targetId: list[i].targetId || '', // 群聊头像用
                        id: list[i].targetId || '', // 给群聊一个id,addedGroup、removedGroup需要id
                        name: list[i].targetName
                            ? list[i].targetName.replace(reg, '')
                            : '',
                        htmlName: list[i].targetName || '',
                        portraitUrl: list[i].icon || '',
                        memberCount: list[i].targetNum || '',
                        memberList: list[i].memberList || []
                    }
                    tempList.push(obj)
                }
            }
            return tempList
        },
        // 选择联系人
        checkContacts(event, item) {
            this.$emit('checkContacts', event, item)
        },
        isHalf(item) {
            const idList = this.selectedHalfGroups.map(item => item.id)
            return idList.indexOf(item.targetId) > -1
        },
        // 选择群聊
        checkGroups(event, groupItem) {
            this.$emit('checkGroups', event, groupItem)
        },
        // 查看全部
        changeTabs(item) {
            const prop = {
                name: item
            }
            this.$emit('changeTabs', prop)
        },
        /* 成员的禁用状态，是否可选择、取消。 1.默认选中成员 */
        isDisabled(item) {
            item.id = item.uId || item.id
            return (
                this.isDefault(item) ||
                this.isDelete(item) ||
                this.executiveLimit(item) ||
                this.isCannotSelected(item) ||
                (this.isBot(item) && this.groupSelectType === 0)
            )
        },
        isDefault(item) {
            return this.defaultIdList.indexOf(item.id) >= 0
        },
        isDelete(item) {
            const isDelete = item && +item.status !== 1 // status是0或2的人不能被选中 0离职2禁用
            return isDelete
        },
        // 是否高管
        executiveLimit(item) {
            if (this.isStaff && this.userLevel >= 1) {
                return false
            }
            const isExec = item && !!+item.isExec
            return isExec
        },
        isCannotSelected(item) {
            return this.canNotSelectedIds.indexOf(item.id) >= 0
        },
        // 是否机器人和文件小助手
        isBot(item) {
            return (
                item.id.indexOf('YTS_BOT_') >= 0 ||
                item.id === this.fileTransferRobotId
            )
        }
    }
}
</script>

<style lang="scss" scoped>
.searchAll {
    height: 100%;
    overflow-y: auto;
    .title {
        width: 100%;
        height: 40px;
        box-sizing: border-box;
        padding: 12px 0 0 12px;
        font-size: 14px;
        font-weight: 600;
        color: #464646;
    }
    .viewAll {
        width: 100%;
        height: 24px;
        box-sizing: border-box;
        padding-right: 12px;
        font-size: 12px;
        font-weight: 600;
        color: #007af5;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        cursor: pointer;
        .viewIcon {
            width: 18px;
            height: 18px;
            margin-right: 6px;
        }
    }
    .division {
        width: 100%;
        height: 7px;
        box-sizing: border-box;
        padding: 6px 12px 0;
        .line {
            width: 100%;
            height: 1px;
            background-color: #f5f5f5;
        }
    }
    .searchContacts {
        .member-box {
            .member {
                display: flex;
                //align-items: center;
                min-height: 54px;
                cursor: pointer;
                border-radius: 4px;
                margin: 0 6px;
                padding: 8px 6px 7px;
                box-sizing: border-box;
                &:hover {
                    background: #f5f5f5;
                }
                .avatar {
                    width: 36px;
                    height: 36px;
                    margin: 0 12px;
                }
                .detail.contact {
                    flex: 1;
                    overflow: hidden;
                    .name {
                        font-size: 14px;
                        line-height: 22px;
                        color: #323232;
                        overflow: hidden;
                        display: flex;
                        .name-flex {
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            max-width: 115px;
                            padding-right: 6px;
                            flex-shrink: 0;
                        }
                        .nick-name {
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                        }
                        .account {
                            flex: 1;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                        }
                    }
                    .position {
                        font-size: 12px;
                        line-height: 18px;
                        color: #999999;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                    }
                    .phone {
                        margin-top: 2px;
                        line-height: 18px;
                    }
                    .recent {
                        width: 52px;
                        height: 18px;
                        margin-top: 2px;
                        background: rgba(0, 122, 245, 0.06);
                        border-radius: 2px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        .recentText {
                            color: #007af5;
                            font-size: 12px;
                            transform: scale(0.83);
                        }
                    }
                    .quit {
                        width: 46px;
                        height: 18px;
                        margin-top: 2px;
                        background: #eaeaea;
                        border-radius: 2px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        .quitText {
                            color: #999;
                            font-size: 12px;
                            transform: scale(0.83);
                        }
                    }
                    ::v-deep .search_high_light {
                        color: #007af5;
                    }
                }
                .detail.group {
                    flex: 1;
                    overflow: hidden;
                    .name {
                        font-size: 14px;
                        line-height: 22px;
                        color: #323232;
                        overflow: hidden;
                        display: flex;
                        .name-flex {
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            max-width: 156px;
                            padding-right: 6px;
                        }
                        .group-count {
                            flex: 1;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                        }
                    }
                    .position {
                        font-size: 12px;
                        line-height: 18px;
                        color: #999999;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                    }
                }
                .expandIcon {
                    width: 18px;
                    height: 18px;
                }
            }
        }
    }
    .searchGroups {
        .searchGroupDetail {
            .member {
                display: flex;
                align-items: center;
                height: 54px;
                cursor: pointer;
                border-radius: 4px;
                margin: 0 6px;
                padding: 0 6px;
                &:hover {
                    background: #f5f5f5;
                }
                .avatar {
                    width: 36px;
                    height: 36px;
                    margin: 0 12px;
                }
                .detail.group {
                    flex: 1;
                    overflow: hidden;
                    .name {
                        font-size: 14px;
                        line-height: 22px;
                        color: #323232;
                        overflow: hidden;
                        display: flex;
                        .name-flex {
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            max-width: 170px;
                            padding-right: 6px;
                            ::v-deep .search_high_light {
                                color: #007af5;
                            }
                        }
                        .group-count {
                            flex: 1;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                        }
                    }
                    .position {
                        width: 100%;
                        font-size: 12px;
                        line-height: 18px;
                        color: #999999;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        ::v-deep .search_high_light {
                            color: #007af5;
                        }
                    }
                }
                .expandIcon {
                    font-size: 18px;
                    color: #c1c1c1;
                }
            }
        }
    }
    .checkIcon {
        cursor: pointer;
        display: flex;
        //align-items: center;
        padding-top: 8px;
        box-sizing: border-box;
        input {
            display: none;
            & + i {
                width: 24px;
                height: 24px;
                display: block;
                background: url('../../../assets/images/contacts/org-window-choose-default.png');
                background-size: 100% 100%;
            }
            &:checked + i {
                width: 24px;
                height: 24px;
                display: block;
                background: url('../../../assets/images/contacts/org-window-choose-ok.png');
                background-size: 100% 100%;
            }
            &:checked[disabled] + i {
                width: 24px;
                height: 24px;
                display: block;
                background: url('../../../assets/images/contacts/org-window-choose-no.png');
                background-size: 100% 100%;
            }
            &[disabled] + i {
                width: 24px;
                height: 24px;
                display: block;
                background: url('../../../assets/images/contacts/org-window-choose-disableno.png');
                background-size: 100% 100%;
            }
            &[half] + i {
                width: 24px;
                height: 24px;
                display: block;
                background: url('../../../assets/images/contacts/org-window-choose-half.png');
                background-size: 100% 100%;
            }
        }
    }
    .org-status {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .status-img {
            width: 90px;
            height: 90px;
        }
        .status-text {
            font-size: 14px;
            line-height: 22px;
            color: #464646;
            text-align: center;
            padding: 12px;
            box-sizing: border-box;
            .no-data {
                color: #007af5;
            }
        }
        .status-reload {
            width: 180px;
            height: 36px;
            margin-top: 18px;
            .reload {
                width: 100%;
                height: 36px;
                font-size: 14px;
                color: #fff;
                text-align: center;
                line-height: 36px;
                border: 0;
                background: #007af5;
                border-radius: 2px;
                cursor: pointer;
                &:hover {
                    background-color: #006edd;
                }
            }
        }
    }
}
</style>
